import { Link } from "@tanstack/react-router";

const COPYRIGHT_YEAR = 2026;

export function Footer() {
  return (
    <footer className="mt-24 border-t border-border/70 bg-secondary/40">
      <div className="container-luxe grid gap-10 py-16 md:grid-cols-4">
        <div>
          <div className="font-display text-xl tracking-tight">European Wig Luxury</div>
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">
            Premium virgin European hair. Hand-tied, cuticle-aligned, unprocessed.
          </p>
        </div>
        <div>
          <p className="eyebrow mb-4">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-foreground text-muted-foreground">All wigs</Link></li>
            <li><Link to="/shop" search={{ audience: "alopecia" }} className="hover:text-foreground text-muted-foreground">For alopecia</Link></li>
            <li><Link to="/shop" search={{ audience: "chemo" }} className="hover:text-foreground text-muted-foreground">For chemotherapy</Link></li>
            <li><Link to="/shop" search={{ audience: "religious" }} className="hover:text-foreground text-muted-foreground">Modest wear</Link></li>
            <li><Link to="/shop" search={{ audience: "fashion" }} className="hover:text-foreground text-muted-foreground">Fashion</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">Support</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/care" className="hover:text-foreground text-muted-foreground">Care guide</Link></li>
            <li><Link to="/faq" className="hover:text-foreground text-muted-foreground">FAQ</Link></li>
            <li><Link to="/faq" hash="insurance" className="hover:text-foreground text-muted-foreground">Insurance & HSA</Link></li>
            <li><Link to="/contact" className="hover:text-foreground text-muted-foreground">Contact</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">Legal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/shipping" className="hover:text-foreground text-muted-foreground">Shipping</Link></li>
            <li><Link to="/legal/returns" className="hover:text-foreground text-muted-foreground">Returns & refunds</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-foreground text-muted-foreground">Privacy policy</Link></li>
            <li><Link to="/legal/terms" className="hover:text-foreground text-muted-foreground">Terms of service</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/70">
        <div className="container-luxe flex flex-col items-start justify-between gap-2 py-6 text-xs text-muted-foreground md:flex-row md:items-center">
          <p>© {COPYRIGHT_YEAR} European Wig Luxury. All rights reserved.</p>
          <p>Cranial prosthesis invoices available on request.</p>
        </div>
      </div>
    </footer>
  );
}
